import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/General/PluginAddDeleteList";
import {PostToPbx, PostToPbx2} from "../../../../api/http-post";
import {LoadDataAnyEndpoint} from "../../../../api/fn";


class SettingAllocationCompanyToCloudcallPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data:[],
            Voips: [],
            Users: [],
            isLoading: false,
            component: "list",
            newEntry: {},
            selectedCompany: "",
            selectedProject: "",
            Queues: [],
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        //await this.loadData("modules","Projects");
        await this.loadData("AllocationUserViop", "Voips", (data) => this.fetchVoipQueue(data));
        await this.loadUsers();
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        // hub.Org = userInfo.Org;
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }

    fetchVoipQueue = async (data) => {
        let _this = this;
        let hub = {};
        await this.PostExternal(hub, "/manager/entity/list/queues", "Extensions", (data) => {
            let ls = [];
            for (let i in data) {
                let row = data[i];
                ls.push(row)
            }
            _this.setState({
                Queues: ls
            })
        })
    }
    getInfoLogin = () => {
        let user = GetUserToken();
        let username = user.Username, role = user.Role, org = user.Org, outbound = '';
        for (let i in this.state.Voips) {
            let row = this.state.Voips[i];
            if (row.user === username) {
                org = row.companycode;
                outbound = row.outboundnumber
            }
        }
        return {org, role, username, outbound}
    }
    loadData = async (targetEntity, stateKey, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            await _this.setState({
                [stateKey]: data.RESULT
            })
            feedback(data.RESULT);
        });
    }
    PostExternal = async (hub, endpoint, stateKey, feedback) => {
        await PostToPbx2(hub, endpoint, async (dataIn) => {
            let data = [];
            if (dataIn !== null) {
                data = dataIn.RESULT;
            }
            console.log(endpoint + " response ---> ", endpoint, " > ", hub, data);
            feedback(data)
        });
    }


    getValuesStateOptions = (stateKey, innerKey, innerDisplay, orgKey) => {
        let data = this.state[stateKey];
        let ls = [];
        for (let i in data) {
            let row = data[i];
            let key = row[innerKey];
            let val = row[innerDisplay];
            console.log("getValuesStateOptions > ", row, " > ", this.state.selectedCompany, " > ", this.state.selectedProject);
            if (row[orgKey] !== this.state.selectedCompany) {
                continue
            }
            ls.push({
                key: key,
                val: val
            });
        }
        return ls
    }
    getQueuesOptions = () => {
        let ls = [];
        let {org,role}=this.getInfoLogin()
        for (let i in this.state.Queues) {
            let row = this.state.Queues[i];
            if (org === row.Org) {
                ls.push({
                    key: row.Name,
                    val: row.Name.toLocaleUpperCase()
                })
            }
        }
        return ls
    }

    render() {
        //const projects = this.getValuesStateOptions("Projects","name","name","org");
        const users = this.getValuesStateOptions("Users", "Username", "FullName", "Org");
        const queues = this.getQueuesOptions()
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Allocate User to Queue</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"AllocationCompanyVoip"}
                            depending={{
                                "org": {targetKey: "CustomerNumber", displayKey: "Name", storageTable: "Companies"},
                            }}
                            fields={[

                                {
                                    name: "companycode",
                                    dataType: "string",
                                    required: true,
                                    label: "Company",
                                    options: []
                                },
                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"AllocationCompanyVoip"}

                            addFormText={"Company To CloudCall"}
                            stepTitle={"Set Up new Allocation Company Cloudcall"}
                            displayRules={[
                                {rowKey: "org", stateKey: "selectedCompany"},
                                /*{rowKey:"module",stateKey:"selectedProject"}*/
                            ]}
                            filterByCompany={true}
                            filterByModule={false}
                            injectFields={[
                                {
                                    rowKey: "Org",
                                    stateKey: "selectedCompany",
                                    errorMsg: "Sorry you can't save, Please select your company!"
                                },
                                /*{rowKey:"Module",stateKey:"selectedProject",errorMsg:"Sorry you can't save, Please select your Project!"}*/
                            ]}
                        />
                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(SettingAllocationCompanyToCloudcallPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
